import { TFunction } from 'i18next';

import { BrainVersionSelection } from '@/components/atoms/BrainVersionSelector';
import { Action, ActionType } from '@/shared/types/rules';
import { isValidSlug } from '@/util/validation/patterns';

import { ACTION_LABEL_KEYS } from './constants';

const REQUIRED_FIELD: Partial<Record<ActionType, keyof Action>> = {
  [ActionType.ASSIGN_BRAIN]: 'brain_parent_id',
  [ActionType.ASSIGN_DEPARTMENT]: 'department_id',
  [ActionType.APPLY_BUNDLE]: 'bundle_id',
  [ActionType.ASSIGN_COLLECTION]: 'collection_id',
  [ActionType.ADD_TAG]: 'tag',
};

export const getActionLabel = (t: TFunction, type: string) =>
  ACTION_LABEL_KEYS[type] ? t(ACTION_LABEL_KEYS[type]) : type;

export const needsActionValue = (type: ActionType) => Boolean(REQUIRED_FIELD[type]);

export const hasActionValue = (action: Action) => {
  const field = REQUIRED_FIELD[action.type];
  return !field || Boolean(action[field]);
};

export const isActionComplete = (action: Action) =>
  hasActionValue(action) && (action.type !== ActionType.ADD_TAG || isValidSlug(action.tag ?? ''));

export const toAiAgentAction = (selection: BrainVersionSelection | null): Action => {
  if (!selection) {
    return { type: ActionType.ASSIGN_BRAIN };
  }
  return {
    type: ActionType.ASSIGN_BRAIN,
    brain_parent_id: selection.brain_parent_id,
    brain_version: selection.brain_version,
  };
};
